export default {
  SAVE_COMPANY: 'saveCompany',
  GET_ALL_COMPANIES: 'getAllCompanies',
  DELETE_COMPANY: 'deleteCompany',
  GET_COMPANIES_BY_TENANT: 'getCompaniesByTenant',
  GET_COMPANIES_BY_USER_GROUP: 'getCompaniesByUserGroup',
  ADD_COMPANY_GROUP_RELATIONSHIP_BY_KEY: 'addCompanyUserGroupRelationshipByKey',
  DELETE_COMPANY_GROUP_RELATIONSHIP: 'deleteCompanyUserGroupRelationship',
}